import { render, staticRenderFns } from "./AuditsTab.vue?vue&type=template&id=e34e7de8&scoped=true&"
import script from "./AuditsTab.vue?vue&type=script&lang=ts&"
export * from "./AuditsTab.vue?vue&type=script&lang=ts&"
import style0 from "./AuditsTab.vue?vue&type=style&index=0&id=e34e7de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34e7de8",
  null
  
)

export default component.exports